import { http } from '../rest';

export function updateFee(http, demo) {
  return {
    async execute({
      id, fee, message, isClientPending,
    }) {
      /* istanbul ignore next: development data */
      if (demo) {
        return {
          id,
          fee,
        };
      }

      await http.put(`/clients/${id}/fee`, {
        fee, message, is_client_pending: isClientPending,
      });

      return { id, fee };
    },
  };
}

export default updateFee(http, process.env.DEMO);
